// removed by extract-text-webpack-plugin
module.exports = {"hover":"src-components-modules-CustomerStory-style----general-module---hover---213Cb transitionTimingFunction-cv-easeOutCircular transitionDuration-xl","imageHover":"src-components-modules-CustomerStory-style----general-module---imageHover---3fj83 overflow-hidden textAlign-center breakPointM-textAlign-left"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/CustomerStory/style/general.module.css
// module id = 733
// module chunks = 33019919093843 122353984331245